export default __webpack_public_path__ + "static/media/eth-coin.76f9f8b8.png";